import * as Yup from "yup";
import dayjs from "dayjs";

import {
    validationSchema as adjustmentValidationSchema,
    validationRowSchema as adjustmentValidationRowSchema,
    initialValues as adjustmentInitialValues,
    initialRowValues as adjustmentInitialRowValues
} from "./adjustmentSchema";

export const validateRowSchema = Yup.object().shape({
    itemId: Yup
        .string(),
    // .required("Required"),
    name: Yup
        .string()
        .required("Required"),
    description: Yup
        .string()
        .required("Required"),
    uomId: Yup
        .string()
        .required("Required"),
    qty: Yup
        .number("")
        .positive("Invalid")
        .required("Required"),
    price: Yup
        .number("")
        // .positive("Invalid")
        .required("Required")
})

export const validationSchema = Yup.object({
    locationId: Yup
        .string()
        .required("Required"),
    documentDate: Yup
        .date("Invalid")
        .required("Required")
        .typeError("Invalid"),
    userId: Yup
        .string()
        .required("Required"),
    // shippingBranchId: Yup
    //     .string()
    //     .required("Required"),
    billingBranchId: Yup
        .string()
        .required("Required"),
    rows: Yup.array().of(validateRowSchema),

    adjustments: adjustmentValidationSchema

})

export const initialRowValues = {
    docItemId: "",
    itemId: "",
    name: "",
    code: "",
    description: "",
    qty: "",
    uomName: "",
    uomId: "",
    price: "",
    subtotal: "0.00"
}

export const initialValues = {
    locationId: "",
    locationName: "",
    documentNumber: "",
    documentDate: dayjs(),
    remark: "",
    userId: "",
    username: "",
    // shippingBranchId: "",
    billingBranchId: "",
    scanType: false,

    rows: [initialRowValues],

    totalamount: "0.00",

}